<template>
  <rabbey-top-menu />
</template>
<script>
export default {
  name: "CEO"
};
</script>

<style></style>
